@import 'styles/mixins';
@import 'styles/variables';

.list {
  @include md-regular;
  color: var(--neutral-90);

  .listItem:not(:first-child) {
    margin-top: 6px;
  }
}

.featureContainer {
  margin-top: 16px;
  display: flex;
  flex-direction: column;
}

.buttonContainer {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.featureList {
  margin: 16px 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 8px;

  .feature {
    display: flex;
    align-items: center;
    gap: 6px;
    height: 32px;
    border: 1px solid var(--neutral-10);
    border-radius: 4px;
    padding: 6px;

    &:hover {
      background-color: var(--neutral-5);
    }

    .flagName {
      font-family: Consolas, Monaco, Andale Mono, monospace;
      font-size: 11px;
    }

    .resetFeature {
      @include sm-regular;
      color: var(--action-60);
      margin-left: auto;
    }
  }
}
